import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import Swal from 'sweetalert2';
import 'react-toastify/dist/ReactToastify.css';
import axios from 'axios';
import '../sunpharma(1)/css/mcq.css';

import Footer from '../components/footer';
import Com_Logo from '../components/company_icon';

const MCQPage = () => {
  const navigate = useNavigate();

  const dr_id = sessionStorage.getItem('com_id');
  const event = sessionStorage.getItem('event');
  const lea_event = sessionStorage.getItem('lea_event');
  const user_type = sessionStorage.getItem('user_type');

  console.log('dr_id :',dr_id);
  console.log('event :',event);
  console.log('lea_event :',lea_event);
  console.log('user_type :',user_type);

  const [questionsData, setQuestionsData] = useState([]);
  const [answers, setAnswers] = useState([]);

  // console.log('mcq data',questionsData)

// FETCH = 'http://localhost/PROJECT/REACT/lms/src/api/ans.php';
// SUBMIT = 'http://localhost/PROJECT/REACT/lms/src/api/insert_mcq.php';

//***live**

//fetch : ./api/ans.php
//submit : ./api/insert_mcq.php

  const API_FETCH = './api/ans.php';
  const API_SUBMIT = './api/insert_mcq.php';

  // 🔹 Fetch MCQs
    useEffect(() => {
      if (!event || !lea_event || !user_type) {
        toast.error('Missing session data');
        return;
      }
    
      axios.get(API_FETCH, { params: { event, lea_event, user_type } })
        .then(res => {
          if (Array.isArray(res.data)) {
            const cleaned = res.data.filter(Boolean);
            setQuestionsData(cleaned);
            setAnswers(Array(cleaned.length).fill(null));
          } else {
            // console.error('Unexpected response:', res.data);
          }
        })
        .catch(err => {
          // console.error('API fetch failed:', err);
        });
    }, []);

  // 🔹 Handle option select
  const handleOptionChange = (qIndex, selectedLabel) => {
    const selectedOption = questionsData[qIndex].options.find(opt => opt.label === selectedLabel);
    const fullValue = `${selectedOption.label}. ${selectedOption.text}`;
  
    const updated = [...answers];
    updated[qIndex] = fullValue;
    setAnswers(updated);
  };
  

  // 🔹 Submit form
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (answers.includes(null)) {
      toast.warning('Please answer all questions !');
      return;
    }

    try {
      const res = await fetch(API_SUBMIT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ dr_id, event, lea_event, answers })
      });

      const data = await res.json();

      if (data.status) {
        Swal.fire({
          icon: 'success',
          title: 'Thanks !',
          text: 'Your answers have been submitted.',
          timer: 3000,
          showConfirmButton: false
        }).then(() => navigate('/mcq_ans'));
      } else {
        Swal.fire({ icon: 'error', title: 'Oops!', text: data.message });
      }
    } catch (err) {
      // console.error("Submit error:", err);
      Swal.fire({ icon: 'error', title: 'Error', text: 'Submission failed.' });
    }
  };

  return (
    <>
      <Com_Logo />
         
      <div className='con'>
        <form onSubmit={handleSubmit}>
          <div className="mcq-container">
            <input type="hidden" name="dr_id" value={dr_id} readOnly />
            <input type="hidden" name="event" value={event} readOnly />
            <input type="hidden" name="lea_event" value={lea_event} readOnly />

            <h2 className="mcq-title">MCQ Test</h2>

            {questionsData.map((question, qIndex) => (
                <div className="question-box" key={qIndex}>
                  <p className="question-text">{`Q${qIndex + 1}: ${question.question}`}</p>

                  <div className="options">
                    {question.options.map((opt, optIndex) => {
                      const fullValue = `${opt.label}. ${opt.text}`;
                      return (
                        <label key={optIndex} className={`option ${answers[qIndex] === fullValue ? 'selected' : ''}`}>
                          <input
                            type="radio"
                            name={`question-${qIndex}`}
                            value={opt.label}
                            checked={answers[qIndex] === fullValue}
                            onChange={() => handleOptionChange(qIndex, opt.label)}
                          />
                          {opt.label}. {opt.text}
                        </label>
                      );
                    })}
                  </div>
                </div>
              ))}


            <button className="submit-button" type="submit" style={{margin: "2rem auto 90px"}}>
            Submit
            </button>

            <ToastContainer />
          </div>
          <Footer />
        </form>
      </div>
    </>
  );
};

export default MCQPage;

